import { useMemo } from 'react'
import { RRule } from '@guestgoodie/helpers'
import { useLingui } from '@lingui/react/macro'

import { EndType, MonthType, WeekOption } from '../types'

export function useFrequencyToLabel() {
  const { t } = useLingui()

  return useMemo(() => {
    return {
      [RRule.SECONDLY]: t`Secondly`,
      [RRule.MINUTELY]: t`Minutely`,
      [RRule.HOURLY]: t`Hourly`,
      [RRule.DAILY]: t`Daily`,
      [RRule.WEEKLY]: t`Weekly`,
      [RRule.MONTHLY]: t`Monthly`,
      [RRule.YEARLY]: t`Yearly`
    }
  }, [t])
}

export function useFrequencyOptions() {
  const frequencyToLabel = useFrequencyToLabel()

  return useMemo(() => {
    return [
      {
        label: frequencyToLabel[RRule.DAILY],
        value: RRule.DAILY
      },
      {
        label: frequencyToLabel[RRule.WEEKLY],
        value: RRule.WEEKLY
      },
      {
        label: frequencyToLabel[RRule.MONTHLY],
        value: RRule.MONTHLY
      },
      {
        label: frequencyToLabel[RRule.YEARLY],
        value: RRule.YEARLY
      }
    ]
  }, [frequencyToLabel])
}

export function useEndOptions() {
  const { t } = useLingui()

  return useMemo(() => {
    return [
      {
        label: t`never`,
        value: EndType.never
      },
      {
        label: t`on`,
        value: EndType.until
      }
    ]
  }, [t])
}

export function useWeekdayToLabel() {
  const { t } = useLingui()

  return useMemo(() => {
    return {
      [RRule.MO.weekday]: t`Monday`,
      [RRule.TU.weekday]: t`Tuesday`,
      [RRule.WE.weekday]: t`Wednesday`,
      [RRule.TH.weekday]: t`Thursday`,
      [RRule.FR.weekday]: t`Friday`,
      [RRule.SA.weekday]: t`Saturday`,
      [RRule.SU.weekday]: t`Sunday`
    }
  }, [t])
}

export function useDayOptions() {
  const weekdayToLabel = useWeekdayToLabel()

  return useMemo(() => {
    return [
      {
        label: weekdayToLabel[RRule.MO.weekday],
        value: RRule.MO.weekday
      },
      {
        label: weekdayToLabel[RRule.TU.weekday],
        value: RRule.TU.weekday
      },
      {
        label: weekdayToLabel[RRule.WE.weekday],
        value: RRule.WE.weekday
      },
      {
        label: weekdayToLabel[RRule.TH.weekday],
        value: RRule.TH.weekday
      },
      {
        label: weekdayToLabel[RRule.FR.weekday],
        value: RRule.FR.weekday
      },
      {
        label: weekdayToLabel[RRule.SA.weekday],
        value: RRule.SA.weekday
      },
      {
        label: weekdayToLabel[RRule.SU.weekday],
        value: RRule.SU.weekday
      }
    ]
  }, [weekdayToLabel])
}

export function useMonthDayTypes() {
  const { t } = useLingui()

  return useMemo(() => {
    return [
      {
        label: t`Specific day`,
        value: MonthType.SPECIFIC_DAY
      },
      {
        label: t`Weekday`,
        value: MonthType.WEEKDAY
      }
    ]
  }, [t])
}

export function useWeekOptionToLabel() {
  const { t } = useLingui()

  return useMemo(() => {
    return {
      [WeekOption.FIRST]: t`First`,
      [WeekOption.SECOND]: t`Second`,
      [WeekOption.THIRD]: t`Third`,
      [WeekOption.FOURTH]: t`Fourth`,
      [WeekOption.FIFTH]: t`Fifth`,
      [WeekOption.LAST]: t`Last`
    }
  }, [t])
}

export function useWeekOptions() {
  const weekOptionToLabel = useWeekOptionToLabel()

  return useMemo(() => {
    return [
      {
        label: weekOptionToLabel[WeekOption.FIRST],
        value: WeekOption.FIRST
      },
      {
        label: weekOptionToLabel[WeekOption.SECOND],
        value: WeekOption.SECOND
      },
      {
        label: weekOptionToLabel[WeekOption.THIRD],
        value: WeekOption.THIRD
      },
      {
        label: weekOptionToLabel[WeekOption.FOURTH],
        value: WeekOption.FOURTH
      },
      {
        label: weekOptionToLabel[WeekOption.FIFTH],
        value: WeekOption.FIFTH
      },
      {
        label: weekOptionToLabel[WeekOption.LAST],
        value: WeekOption.LAST
      }
    ]
  }, [weekOptionToLabel])
}
